import React, { useState, useEffect, useRef } from 'react';
import { Route, Redirect, useLocation } from 'react-router-dom';
import { ContainerBody } from "components";
import { Browser } from "core/utils";
import { STORAGE_KEYS } from "core/utils/constants";
import AuthApi from 'apis/AuthApi';
import ApiStore from 'stores/ApiStore';

const AuthRoute = ({ component: Component, path, exact, ...rest }) => {
	const [loading, setLoading] = useState(true);
	const [isAuthenticated, setIsAuthenticated] = useState(false);
	const [isOtpChallenging, setIsOtpChallenging] = useState(false);
	const location = useLocation();
	const prevPathnameRef = useRef(location.pathname);
	const authApi = new AuthApi();

	// ルート変更を即座に検知
	const isRouteChanged = prevPathnameRef.current !== location.pathname;

	useEffect(() => {
		let isMounted = true;

		// ルート変更時に即座にloadingとisAuthenticatedをリセット
		setLoading(true);
		setIsAuthenticated(false);
		setIsOtpChallenging(false);
		prevPathnameRef.current = location.pathname;

		// セッション確認APIの実行
		ApiStore.call(
			authApi,
			authApi.confirmSession,
		).then(response => {
			if (isMounted) {
				if (response) {
					setIsAuthenticated(true);
					setIsOtpChallenging(false);
					setLoading(false);
				} else {
					const preSessionId = Browser.getSavedInfo(STORAGE_KEYS.PRESESSION_ID);
					if (preSessionId && preSessionId !== "undefined") {
						setIsOtpChallenging(true);
					}
					setIsAuthenticated(false);
					setLoading(false);
				}
			}
		}).catch(() => {
			if (isMounted) {
				const preSessionId = Browser.getSavedInfo(STORAGE_KEYS.PRESESSION_ID);
				if (preSessionId && preSessionId !== "undefined") {
					setIsOtpChallenging(true);
				}
				setIsAuthenticated(false);
				setLoading(false);
			}
		});

		// クリーンアップ関数：コンポーネントがアンマウントされたときに実行
		return () => {
			isMounted = false;
		};
	}, [location.pathname]);

	return (
		<Route
			path={path}
			exact={exact}
			render={(props) => {
				// ルート変更直後またはローディング中は空のdivを表示
				if (loading || isRouteChanged) {
					return <ContainerBody disableTrackScrollBar={true} dummy={true} />;
				}

				// 認証失敗の場合はログインページにリダイレクト
				if (isOtpChallenging) {
					return <Redirect to={{ pathname: "/otp", state: { from: location } }} />;
				} else if (!isAuthenticated) {
					return <Redirect to={{ pathname: "/login", state: { from: location } }} />;
				}

				// 認証成功の場合のみ子コンポーネントをレンダリング
				// propsにはmatch, location, historyが正しく含まれる
				return <Component {...props} {...rest} />;
			}}
		/>
	);
};

export default AuthRoute;
